import { Box, Grid, SxProps, Theme, Typography } from '@mui/material';
import React, { forwardRef, PropsWithChildren } from 'react';

export type CustomMultiSelectContainerProps = {
    label?: JSX.Element;
    open?: boolean;
    sx?: SxProps<Theme>;
};

export const CustomMultiSelectContainer = forwardRef<HTMLDivElement, PropsWithChildren<CustomMultiSelectContainerProps>>(
    ({ label, open, sx, children }, ref) => (
        <Box
            ref={ref}
            sx={(theme) => ({
                width: '100%',
                height: '100%'
            })}
        >
            <Grid
                container
                sx={(theme) => ({ height: '100%', backgroundColor: open ? theme.palette.secondary.light : theme.palette.primary[300] })}
                justifyContent={label ? 'space-between' : 'flex-end'}
            >
                {label && (
                    <Grid item xs={4} container alignItems="center" sx={{ height: '100%' }}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '13px',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                color: '#616161'
                            }}
                        >
                            {label}
                        </Typography>
                    </Grid>
                )}
                <Grid item xs={label ? 8 : 12} sx={{ height: '100%' }}>
                    {children}
                </Grid>
            </Grid>
        </Box>
    )
);
